import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeInitDeviationXHRCall } from '../../../simpleXHR/actionCreators';
import { getInitDeviationXHRCallResult } from '../../../simpleXHR/selectors';
export default ((initialDeviation)=>{
    const dispatch = useDispatch();
    const { deviation: extendedDeviation } = useSelector(getInitDeviationXHRCallResult) || {};
    useEffect(()=>{
        if (initialDeviation.extended) {
            return;
        }
        dispatch(makeInitDeviationXHRCall(initialDeviation));
    }, [
        dispatch,
        initialDeviation
    ]);
    return extendedDeviation || initialDeviation;
});

//# sourceMappingURL=useExtendedDeviation.js.map